
/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class Controller {
    /** @type {HTMLElement} */
    #dialogAnchorNode;
    /** @type {DataManager} */
    #dataManager;
    /** @type {Logger} */
    #logger;

    /**
     *
     * @param dialogAnchorNode {HTMLElement}
     * @param dataManager {DataManager}
     * @param logger {Logger}
     */
    constructor(dialogAnchorNode, dataManager, logger) {
        this.#dialogAnchorNode = dialogAnchorNode;
        this.#dataManager = dataManager;
        this.#logger = logger;
    }

    getDialogAnchor() {
        return this.#dialogAnchorNode;
    }

    getDataManager() {
        return this.#dataManager;
    }

    getLogger() {
        return this.#logger;
    }
}
